module.exports = __webpack_public_path__ + "img/logo-tall.7c09bc6c.png";